import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalNewsService } from "services/ClientPortalNewsService";
import { ClientPortalNewsModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type DevelopmentNewsPostState = {
  Loading: boolean;
  NewsPost: ClientPortalNewsModel | undefined;
};

const initialState: DevelopmentNewsPostState = {
  Loading: false,
  NewsPost: undefined,
};

const newsPostSlice = createSlice({
  name: "newsPost",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNewsPost.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getNewsPost.fulfilled, (state, action) => {
        state.NewsPost = action.payload;
        state.Loading = false;
      })
      .addCase(getNewsPost.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getNewsPost = createAsyncThunk<ClientPortalNewsModel, string>(
  "NewsPost/GetNewsPost",
  async (developmentNewsID) => {
    const newsService = container.get<IClientPortalNewsService>(SERVICE_TYPES.CPLClientPortalNewsService);
    return await newsService.getNewsPost(developmentNewsID);
  }
);

export const { resetState } = newsPostSlice.actions;

export const selectNewsPost = (state: RootState) => state.newsPost.NewsPost;
export const selectLoading = (state: RootState) => state.newsPost.Loading;

export default newsPostSlice.reducer;
